import React from 'react';
import styles from './RegularCard.module.css';
import { Trans, useTranslation } from 'react-i18next';
import type { Course, PricingPlan } from './CourseCard.types';

type Props = {
  course: Course;
  i18nIndex: number;
  price?: PricingPlan;
  onBuy?: () => void;
};

const RegularCard: React.FC<Props> = ({
  course,
  i18nIndex,
  price,
  onBuy,
}) => {
  const { t } = useTranslation();

const toneClass =
  course.titleTone === 'gold'
    ? styles.toneGold
    : course.titleTone === 'red'
    ? styles.toneRed
    : '';

const highlightClass = course.titleTone === 'gold' ? styles.highlight : '';

return (
  <div className={`${styles.card} ${toneClass} ${highlightClass}`}>
      <div className={styles.header}>
        <h3 className={styles.title} data-title={course.title}>
          {course.title}
        </h3>

        <p className={styles.price} data-title={course.title}>
          {price && (
            <>
              <span className={styles.priceByn}>{price.byn} BYN </span>
              <span className={styles.priceEur}>(€{price.eur}*)</span>
            </>
          )}
        </p>
      </div>

      <div className={styles.details}>
        <span className={styles.period}>{course['pricing-label']}</span>
        <span className={styles.monthly}>{price ? `${price.monthly} RUR` : ''}</span>
      </div>

      <div className={styles.separator} />

      <ul className={styles.list}>
        {course.access && (
          <li className={styles.listItem}>
            <div className={styles.listIcon} />
            <div className={styles.listText}>
              <Trans
                i18nKey={`coursePricing.cards.${i18nIndex}.included`}
                values={{ access: course.access }}
                components={{ br: <br />, span: <span />, strong: <strong /> }}
              />
            </div>
          </li>
        )}

        {course.user?.trim() && (
          <li className={styles.listItem}>
            <div className={styles.listIcon} />
            <div className={`${styles.listText} ${styles.listBold}`}>{course.user}</div>
          </li>
        )}

        {course.payment?.trim() && (
          <li className={styles.listItem}>
            <div className={styles.listIcon} />
            <div className={`${styles.listText} ${styles.listBold}`}>{course.payment}</div>
          </li>
        )}

        {course.library?.trim() && (
          <li className={styles.listItem}>
            <div className={styles.listIcon} />
            <div className={styles.listText}>
              <Trans
                i18nKey={`coursePricing.cards.${i18nIndex}.library`}
                components={{ br: <br />, span: <span />, strong: <strong /> }}
              />
            </div>
          </li>
        )}
      </ul>

      <p className={styles.description}>{course.description}</p>

      <button className={styles.button} onClick={onBuy}>
        <span>{t('coursePricing.button')}</span>
      </button>
    </div>
  );
};

export default RegularCard;